import strings from "@/utils/strings";

export default [
	{
		title: strings.k4noc.titles.moves,
		route: "/tickets/room-moves",
	},
	{
		title: strings.k4noc.titles.device,
		route: "/tickets/device-status",
	},
];
